import cookie from '../js/cookie.js'

const mutations = {
  istoken (state, str) {
    state.token = str
  },
  islogin (state, str) {
    state.token = str
  },
  setProvince (state, data) {
    state.provinceid = data
    sessionStorage.setItem('provinceid', data)
  },
  getlongitude (state, data) {
    state.longitude = data
    sessionStorage.setItem('longitude', data)
  },
  getlatitude (state, data) {
    state.latitude = data
    sessionStorage.setItem('latitude', data)
  },
  setWxUrl (state, data) {
    state.wxUrl = data
    sessionStorage.setItem('wxUrl', data)
  },
  setRefuseAddr (state, data) {
    state.refuseAddress = data
    state.agreeAddress = data
    sessionStorage.setItem('refuseAddress', data)
    sessionStorage.setItem('agreeAddress', data)
  },
  setFirstInProd (state, data) {
    state.firstInProd = data
  },
  setOpenid (state, data) {
    state.openid = data
    sessionStorage.setItem('openid', data)
    sessionStorage.setItem('sitesdktoken', data)
  },
  setType (state, data) {
    state.type = data
    sessionStorage.setItem('type', data)
  },
  'SAVE_SIGNIN' (state, payload) {
    state.singIn = payload
  },
  'SAVE_TYPE' (state, payload) {
    state.type = payload
  },
  'SAVE_GOODS' (state, payload) {
    state.goods = payload
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutation.js